import { IconPlayerStop, IconSend } from '@tabler/icons-react'
import { Box, IconButton, SvgIcon, TextField, Tooltip } from '@mui/material'
import { type KeyboardEvent, useState } from 'react'

interface Props {
  onSend: (content: string) => void
  onStop: () => void
  isStreaming: boolean
  disabled: boolean
}

export const ChatInput = ({ onSend, onStop, isStreaming, disabled }: Props) => {
  const [value, setValue] = useState('')

  const handleSend = () => {
    const trimmed = value.trim()
    if (!trimmed || disabled) return
    onSend(trimmed)
    setValue('')
  }

  const handleKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  return (
    <Box
      sx={{
        p: 1.5,
        borderTop: '1px solid',
        borderColor: 'divider',
        display: 'flex',
        gap: 1,
        alignItems: 'flex-end',
      }}
    >
      <TextField
        fullWidth
        multiline
        maxRows={4}
        size="small"
        placeholder="Ask something…"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        sx={{ '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
      />
      <Tooltip title={isStreaming ? 'Stop' : 'Send'}>
        <span>
          <IconButton
            color={isStreaming ? 'error' : 'primary'}
            onClick={isStreaming ? onStop : handleSend}
            disabled={!isStreaming && (disabled || !value.trim())}
            sx={{ mb: 0.25 }}
          >
            <SvgIcon fontSize="small">{isStreaming ? <IconPlayerStop /> : <IconSend />}</SvgIcon>
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  )
}
